module.exports = ".header-menu-other-show {\r\n    display: block;\r\n}\r\n\r\n.header-menu-main {\r\n    display: inline !important;\r\n    padding: 0 5px 0 5px !important;\r\n    float: left;\r\n}\r\n\r\n.header-menu-seperator {\r\n    border-right: 1px dotted silver;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    margin-right: -5px;\r\n    margin-top: -30px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header-menu/header-menu.component.css
// module id = ./src/app/shared/header-menu/header-menu.component.css
// module chunks = main